import { dateTransformer } from "@/common/utils/dateTransformer";
import { GeneralDocumentData } from "../types/generalDocuments.type";
import { DownloadIcon } from "lucide-react";
import { generalDocumentKinds } from "../constants/generalDocumentKinds.constant";

interface GeneralDocumentGridItemProps {
  generalDocument: GeneralDocumentData;
}

const GeneralDocumentGridItem = ({ generalDocument }: GeneralDocumentGridItemProps) => {
  return (
    <div key={generalDocument.id} className="bg-white-200 rounded-lg p-4 flex flex-col gap-4 relative h-min">
      <div>
        <p className="text-xs italic">
          Nome do documento
        </p>

        <p className="text-sm">
          {generalDocument.display_name || '--'}
        </p>
      </div>

      <div>
        <p className="text-xs italic">
          Tipo do documento
        </p>

        <p className="text-sm">
          {generalDocument.kind ? generalDocumentKinds[generalDocument.kind as keyof typeof generalDocumentKinds] : '--'}
        </p>
      </div>

      <div>
        <p className="text-xs italic">
          Data de validade
        </p>

        <p className="text-sm">
          {generalDocument.expiration_date ? dateTransformer(generalDocument.expiration_date) : '--'}
        </p>
      </div>

      {generalDocument.file?.url && (
        <a
          href={generalDocument.file.url}
          download={generalDocument.display_name}
          target="_blank"
          className="absolute bottom-4 right-4"
        >
          <DownloadIcon />
        </a>
      )}
    </div>
  );
}

export default GeneralDocumentGridItem;
